import { extendableComponent } from '@graphcommerce/next-ui'
import { IconSvg } from '@graphcommerce/next-ui/IconSvg'
import { iconCheckmark } from '@graphcommerce/next-ui/icons'
import { Box, SxProps, Theme, Typography } from '@mui/material'

export type StepperProps = {
  steps: number
  currentStep: number
  sx?: SxProps<Theme>
}

const name = 'Stepper' as const
const parts = ['root', 'step', 'activeStep'] as const
const { classes } = extendableComponent(name, parts)

export function Stepper(props: StepperProps) {
  const { steps, currentStep, sx = [] } = props

  return (
    <Box
      className={classes.root}
      marginTop='lg'
      sx={[
        (theme) => ({
          display: 'grid',
          gridAutoFlow: 'column',
          gap: theme.spacings.xxs,
          background: 'white',
          height: '30px',
          mt: theme.spacings.xl,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {[...Array(steps).keys()].map((step: number) => (
        <Box
          sx={[
            {
              height: 2,
              bgcolor: 'divider',
              position: 'relative',
            },
            currentStep - 1 >= step && {
              bgcolor: 'secondary.main',
            },
          ]}
          className={`${classes.step} ${currentStep - 1 >= step ? classes.activeStep : ''}`}
          key={step}
        >
          <Box
            sx={{
              bgcolor: currentStep - 1 >= step ? 'secondary.main' : '#EAEAEA',
              color: currentStep - 1 >= step ? 'white' : 'black',
              boxShadow: currentStep - 1 === step ? 6 : 'none',
              position: 'absolute',
              width: '30px',
              height: '30px',
              lineHeight: '1.4em',
              textAlign: 'center',
              left: 0,
              right: 0,
              m: '-15px auto',
              borderRadius: '30px',
            }}
          >
            {currentStep - 2 >= step ? (
              <IconSvg
                sx={{ fontSize: '20px', strokeWidth: '2.5px', mt: '5px' }}
                src={iconCheckmark}
              />
            ) : (
              <Typography variant='h6' sx={{ lineHeight: '28px' }}>
                {step + 1}
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  )
}
